import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import './chatTheme.css';

interface KnowledgeArticle {
  id: string;
  titulo: string;
  categoria?: string;
  resumo?: string;
  conteudo?: string;
  atualizadoEm?: string;
}

export function ChatKnowledgeBasePanel() {
  const [query, setQuery] = useState('');
  const [articles, setArticles] = useState<KnowledgeArticle[]>([]);
  const [draft, setDraft] = useState({ titulo: '', categoria: '', conteudo: '' });

  const search = () => {
    api.get('/chat-interno/knowledge/search', { params: { q: query } })
      .then((res) => setArticles(res.data || []));
  };

  useEffect(search, []);

  const createArticle = async () => {
    await api.post('/chat-interno/knowledge/articles', draft);
    setDraft({ titulo: '', categoria: '', conteudo: '' });
    search();
  };

  return (
    <div className="ac-chat-v8-panel">
      <div className="ac-chat-v8-card">
        <h3 className="ac-chat-command-label">Base de conhecimento</h3>
        <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
          <input className="ac-chat-v8-input" value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Buscar procedimento, erro, comunicado..." />
          <button className="ac-chat-action-btn" onClick={search}>Buscar</button>
        </div>
      </div>

      <div className="ac-chat-v8-card">
        <h3 className="ac-chat-command-label">Novo artigo</h3>
        <div style={{ display: 'grid', gap: 8, marginTop: 10 }}>
          <input className="ac-chat-v8-input" value={draft.titulo} onChange={(e) => setDraft((p) => ({ ...p, titulo: e.target.value }))} placeholder="Título" />
          <input className="ac-chat-v8-input" value={draft.categoria} onChange={(e) => setDraft((p) => ({ ...p, categoria: e.target.value }))} placeholder="Categoria" />
          <textarea className="ac-chat-v8-textarea" value={draft.conteudo} onChange={(e) => setDraft((p) => ({ ...p, conteudo: e.target.value }))} placeholder="Conteúdo do procedimento" />
          <button className="ac-chat-action-btn is-success" onClick={createArticle}>Salvar artigo</button>
        </div>
      </div>

      {articles.map((article) => (
        <div key={article.id} className="ac-chat-v8-card">
          <h3 style={{ margin: 0, fontSize: '.9rem', fontWeight: 950 }}>{article.titulo}</h3>
          {article.categoria && <span className="ac-chat-category-pill" style={{ marginTop: 8 }}>{article.categoria}</span>}
          <p className="ac-chat-automation-text" style={{ marginTop: 8 }}>{article.resumo || article.conteudo}</p>
        </div>
      ))}
    </div>
  );
}
